import React from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
import FormView from "./FormView/FormView"
import './App.scss';

function App() {
  return (
    <div className="App">
      <Router basename={process.env.PUBLIC_URL} >
        <Route path="/:id.html" component={FormView} />
      </Router>
    </div>
  );
}

export default App;
